import { createContext, useContext, useState, useEffect } from "react";

const CartContext = createContext();

const STORAGE_KEY = "rainboy_cart";

function loadCart() {
  try {
    const raw = localStorage.getItem(STORAGE_KEY);
    return raw ? JSON.parse(raw) : [];
  } catch {
    return [];
  }
}

export function CartProvider({ children }) {
  const [items, setItems] = useState(loadCart);
  const [drawerOpen, setDrawerOpen] = useState(false);

  useEffect(() => {
    localStorage.setItem(STORAGE_KEY, JSON.stringify(items));
  }, [items]);

  const addItem = (artwork) => {
    if (artwork.sold) return;
    setItems((prev) => {
      if (prev.some((item) => item.id === artwork.id)) return prev;
      return [...prev, {
        id: artwork.id,
        title: artwork.title,
        artist_name: artwork.artist_name,
        image: artwork.image,
        price: artwork.price,
        dimensions: artwork.dimensions,
        shopify_variant_id: artwork.shopify_variant_id || "",
      }];
    });
    setDrawerOpen(true);
  };

  const removeItem = (id) => {
    setItems((prev) => prev.filter((item) => item.id !== id));
  };

  const clearCart = () => setItems([]);
  const isInCart = (id) => items.some((item) => item.id === id);
  const itemCount = items.length;
  const total = items.reduce((sum, item) => sum + (item.price || 0), 0);

  return (
    <CartContext.Provider value={{
      items, addItem, removeItem, clearCart, isInCart, itemCount, total,
      drawerOpen, setDrawerOpen,
    }}>
      {children}
    </CartContext.Provider>
  );
}

export function useCart() {
  return useContext(CartContext);
}
